import VueRouter, { RouteConfig } from 'vue-router'
const Index = () => import('../activity/202503/children-palace/Index.vue')
const Record = () => import('../activity/202503/children-palace/Record.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/202503/children-palace/index',
  name: 'activity_202503_children_palace_index',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2025全国青少年传统体育跳绳比赛',
  },
}

export const recordRoute: RouteConfig = {
  path: '/activity/202503/children-palace/record',
  name: 'activity_202503_children_palace_record',
  component: Record,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '参赛记录',
  },
}

export default [indexRoute, recordRoute]
